import { combineReducers } from 'redux';

import appUnreadCountNotificationSlice from './slices/appUnreadCountNotificationSlice';

const appNotificationsReducer = combineReducers({
  unreadCount: appUnreadCountNotificationSlice,
});
export default appNotificationsReducer;
